import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { K2SelectComponent } from '@k2/common/k2-select/k2-select.component';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { K2AssigneeSelectComponent } from "@k2/common/k2-select/k2-assignee-select.component";
import { MatTooltipModule } from '@angular/material/tooltip';

const components = [K2SelectComponent, K2AssigneeSelectComponent];

@NgModule({
  imports: [
    MatSelectModule,
    FormsModule,
    CommonModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    MatTooltipModule
  ],
  declarations: components,
  exports: components
})
export class K2SelectModule {}
